import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { FaTrash, FaExclamationTriangle, FaCheckCircle, FaInfoCircle, FaEdit } from 'react-icons/fa';
import { useTranslation } from "react-i18next";
import classes from './Modal.module.css'; // Expecting we might need it, or we can use inline/global styles

const ConfirmModal = ({
    show,
    onHide,
    onConfirm,
    title = "Confirm Action",
    message = "Are you sure you want to proceed?",
    variant = "danger", // danger, primary, success, warning
    confirmText,
    cancelText,
    isLoading = false
}) => {
    const { t } = useTranslation();

    // Determine styles based on variant
    let headerClass = "bg-light border-bottom";
    let titleClass = "text-dark";
    let icon = <FaExclamationTriangle className="me-2 text-warning" />;
    let confirmBtnClass = "btn-premium";

    if (variant === "danger" || variant === "delete") {
        headerClass = "bg-light border-bottom";
        titleClass = "text-danger";
        icon = <FaTrash className="me-2" />;
        confirmBtnClass = "btn-danger-premium";
    } else if (variant === "primary" || variant === "update") {
        headerClass = "bg-light border-bottom";
        titleClass = "text-teal"; // Assuming text-teal is available, or use custom color
        icon = <FaEdit className="me-2" />;
        confirmBtnClass = "btn-premium";
    } else if (variant === "success") {
        headerClass = "bg-light border-bottom";
        titleClass = "text-success";
        icon = <FaCheckCircle className="me-2" />;
        confirmBtnClass = "btn-success-premium"; // Ensure this class exists or fallback
    }

    return (
        <>
            <style>
                {`
                  .confirm-backdrop {
                    background-color: rgba(0, 0, 0, 0.5) !important;
                    backdrop-filter: blur(2px);
                  }
                  .confirm-modal-small {
                    max-width: 350px !important;
                    margin: auto !important;
                  }
                  .text-teal { color: var(--primary-color) !important; }
                `}
            </style>
            <Modal
                show={show}
                onHide={onHide}
                centered
                size="sm"
                backdropClassName="confirm-backdrop"
                backdrop="static"
                keyboard={false} // Prevent closing on ESC if critical, or true if friendly
                dialogClassName="confirm-modal-small"
            >
                <Modal.Header closeButton className={headerClass}>
                    <Modal.Title className={`h6 mb-0 d-flex align-items-center ${titleClass}`}>
                        {icon} <span className="ms-1">{typeof title === 'string' ? t(title) : title}</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="py-4 text-center">
                    <div className="mb-2">
                        {typeof message === 'string' ? t(message) : message}
                    </div>
                    {variant === "danger" && (
                        <p className="text-danger small mb-0 fw-bold">{t("This action cannot be undone.")}</p>
                    )}
                </Modal.Body>
                <Modal.Footer className="border-top bg-light p-2 d-flex justify-content-center gap-2">
                    <Button
                        className="btn-secondary-premium py-1 px-3"
                        size="sm"
                        onClick={onHide}
                        disabled={isLoading}
                    >
                        {cancelText || t("Cancel")}
                    </Button>
                    <Button
                        className={`${confirmBtnClass} py-1 px-3`}
                        size="sm"
                        onClick={onConfirm}
                        disabled={isLoading}
                    >
                        {isLoading ? <Spinner animation="border" size="sm" /> : (confirmText || t("Confirm"))}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ConfirmModal;
